import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function AccountCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.558 18.548A9.961 9.961 0 0022 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 2.504.92 4.793 2.442 6.548A10.036 10.036 0 007.636 21c1.319.64 2.8 1 4.364 1a9.96 9.96 0 004.364-1 10.035 10.035 0 003.194-2.452zm-14.056-1.88A6.987 6.987 0 0111 14h2a6.987 6.987 0 015.498 2.667A7.99 7.99 0 0112 20a7.99 7.99 0 01-6.498-3.333zM15 9a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}
export default AccountCircleFill;